import {
  isAssignOperationalFormTaskStackEntry,
  readAssignOperationalFormComment,
} from "@/libs/assignOperationalFormTask";

function escapeHtml(text) {
  if (text == null || text === "") {
    return "";
  }
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export default {
  methods: {
    parseCmdData(cmd) {
      if (cmd.cmd === "ai_decision") {
        return this.formatAIDecisionCmdData(cmd.data);
      }

      if (isAssignOperationalFormTaskStackEntry(cmd)) {
        return this.formatAssignOperationalFormTaskCmdData(
          readAssignOperationalFormComment(cmd.data)
        );
      }

      const cmdData = JSON.stringify(cmd.data, null, 2);

      return `<pre>${cmdData}</pre>`;
    },
    formatAssignOperationalFormTaskCmdData(comment) {
      if (!comment) {
        return "";
      }

      return `<p class="mb-0">${escapeHtml(comment)}</p>`;
    },
    resolveValue(type, val) {
      switch (type) {
        case 'loop':
          return val === true ? this.$t('yes') : this.$t('no');

        case 'location':
          const coords = val.split(',');
          return `${coords[0]}, ${coords[1]}`;

        default:
          return val.name || val;
      }
    },
    resolveParamName(text) {
      return this.$t(`commands.data_types.${text}`);
    },
    resolveSuffix(type) {
      switch (type) {
        case 'delay':
          return this.$t('commands.units.seconds');
        case 'radius':
          return 'm';
        default:
          return '';
      }
    },
    formatAIDecisionCmdData(data) {
      const prompt = data.prompt;
      const aiDecision = data.ai_decision;
      const color = data.color;
      return `
        <ul class="pl-0">
            <li><span>Prompt</span>: ${prompt}</li>
            <li>
                <span class="badge badge-title" style="background-color: ${color}; display: inline-block; margin-bottom: -4px;">
                    ${this.$t('commands.list.ai_decision.decision')}: ${aiDecision}
                </span>
            </li>
        </ul>
      `;
    }
  },
}
